// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Currency: MarkdocTagRegistration = {
  tag: 'currency',
  component: 'Currency',
  selfClosing: true,
  attributes: {
    amount: {
      type: Number,
      required: true,
    },
    zeroDecimalAmount: {
      type: Number,
      required: false,
    },
    overrideCurrency: {
      type: String,
      required: false,
    },
  },
};
